import React, { useState } from 'react';
import FlipBook from '../components/FlipBook';

const Search = ({ lang }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [openPdf, setOpenPdf] = useState(null);

  const labels = {
    fr: {
      title: 'Rechercher',
      placeholder: 'Posez votre question...',
      button: 'Rechercher',
      results: 'résultats pour',
      page: 'Page',
      open: 'Ouvrir page',
      noResults: 'Aucun résultat trouvé',
      examples: 'Exemples : prière, jeûne, mariage, héritage, zakat...',
      backResults: '← Retour aux résultats',
      newSearch: '🔍 Nouvelle recherche'
    },
    en: {
      title: 'Search',
      placeholder: 'Ask your question...',
      button: 'Search',
      results: 'results for',
      page: 'Page',
      open: 'Open page',
      noResults: 'No results found',
      examples: 'Examples: prayer, fasting, marriage, inheritance...',
      backResults: '← Back to results',
      newSearch: '🔍 New search'
    }
  };

  const L = labels[lang];

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    setSearched(true);
    try {
      const res = await fetch(`/api/v1/search/${lang}?q=${encodeURIComponent(query)}&limit=10`);
      const data = await res.json();
      setResults(data.results || []);
    } catch (err) {
      console.error(err);
      setResults([]);
    }
    setLoading(false);
  };

  const cleanTitle = (title) => {
    return title
      .replace(/^\d+[_\s]*/i, '')
      .replace(/^A PROPOS DE LA |^A PROPOS DE L'|^A PROPOS DU |^A PROPOS DES |^About /i, '');
  };

  const openAtPage = (result) => {
    setOpenPdf({
      filename: result.filename,
      title: cleanTitle(result.title),
      page: result.page
    });
  };

  const closePdf = () => {
    setOpenPdf(null);
  };

  const newSearch = () => {
    setOpenPdf(null);
    setQuery('');
    setResults([]);
    setSearched(false);
  };

  if (openPdf) {
    return (
      <div className="search-reader">
        <div className="search-nav-bar">
          <button onClick={closePdf} className="nav-back-btn">{L.backResults}</button>
          <span className="nav-info">"{query}" → {openPdf.title} (p.{openPdf.page})</span>
          <button onClick={newSearch} className="nav-new-btn">{L.newSearch}</button>
        </div>
        <FlipBook
          pdfUrl={`/api/v1/chapter/${lang}/file/${encodeURIComponent(openPdf.filename)}/view`}
          title={`${openPdf.title} - Page ${openPdf.page}`}
          onClose={closePdf}
          lang={lang}
          startPage={openPdf.page}
        />
      </div>
    );
  }

  return (
    <div className="search-page">
      <h1>🔍 {L.title}</h1>
      <form onSubmit={handleSearch} className="search-form">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={L.placeholder}
          className="search-input"
        />
        <button type="submit" className="search-btn" disabled={loading}>
          {loading ? '...' : L.button}
        </button>
      </form>
      <p className="search-hint">{L.examples}</p>
      {searched && (
        <div className="search-results">
          {results.length > 0 ? (
            <>
              <p className="results-count">{results.length} {L.results} "{query}"</p>
              {results.map((r, i) => (
                <div key={i} className="result-card">
                  <div className="result-header">
                    <h3>{cleanTitle(r.title)}</h3>
                    <span className="result-page">{L.page} {r.page}</span>
                  </div>
                  <p className="result-excerpt">{r.excerpt}</p>
                  <button onClick={() => openAtPage(r)} className="result-link">
                    📖 {L.open} {r.page}
                  </button>
                </div>
              ))}
            </>
          ) : (
            <p className="no-results">{L.noResults}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
